import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { toast } from 'react-toastify';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const JudgmentXmlDownloadLink = (props: {
  judgmentId: string;
  judgmentNumber?: string | null;
}) => {
  const spd = useSpdCore();

  const handleClick = async () => {
    try {
      const xml = await spd.judgmentP1Documents.getAcceptedXmlForJudgment(
        props.judgmentId,
      );
      const url = URL.createObjectURL(
        new Blob([xml], { type: 'application/xml' }),
      );
      const link = document.createElement('a');
      link.href = url;
      const cleanedNumber = (props.judgmentNumber || props.judgmentId)
        .replace(/[^\p{L}\p{N}]+/gu, '_')
        .replace(/^_+|_+$/g, '');
      link.download = `Orzeczenie_${cleanedNumber}.xml`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (response) {
      const error = await responseErrors(response as ResponseError);
      toast.error(`Nie udało się pobrać XML orzeczenia. ${error}`);
    }
  };

  return (
    <>
      <OverlayTrigger
        overlay={<Tooltip style={{ position: 'fixed' }}>Pobierz XML</Tooltip>}
      >
        <Button
          onClick={e => {
            e.stopPropagation();
            void handleClick();
          }}
          variant="btn-info"
        >
          <Icon.FileEarmarkCode />
        </Button>
      </OverlayTrigger>
    </>
  );
};
